/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
var LS = app.helpers.StorageHelper.LS;

(function ($) {
  'use strict';

  /**
   * Вид для поля формы с переключением телефона и email
   */
  app.EntityInputFormView = app.View.extend({
    $input: '',
    $countryFlags: '',  // селектор значка флага
    oldEmail: '',
    oldPhone: '',

    events: {
      'click .switch-entity.unselected': 'switchEntity'
    },

    run: function (options) {
      var that = this;
      // указываем когда можно ставить начальные значения поля
      var startPhoneNumbersCondition = function () {
        return that.$input.hasClass('input_phone');
      };
      // указываем когда можно ставить маску ввода
      var maskCondition = function () {
        return that.$input.hasClass('input_phone');
      };
      this.$input = this.$('#entity input');
      this.$countryFlags = this.$('.choice-country');
      this.$countryFlags.hide();
      var phoneInputmaskOptions = {
        el: this.$input,
        startPhoneNumbersCondition: startPhoneNumbersCondition,
        maskCondition: maskCondition
      };
      if ($('#password-reset-request-entity').attr('type') === 'tel') {
        this.$countryFlags.show();
      }
      if (options.countryFlagModel) {
        phoneInputmaskOptions.model = options.countryFlagModel;
      }
      this.phoneInputmaskView = new app.PhoneInputmaskView(phoneInputmaskOptions);
      var lastLoginData = LS.get('lastLoginData');
      if (lastLoginData === 'phone' || lastLoginData === 'email') {
        var $selectBtn = this.$('.switch-entity[data-name="'+lastLoginData+'"]');
        this.switchEntity(null, $selectBtn[0]);
      }
    },
    /**
     * Переключение между email и телефоном
     * @param {Object} selectedTab Элемент $selectBtn
     * @param {Event} event Событие переключения
     */
    switchEntity: function (event, selectedTab) {
      LS.remove('lastLoginData');
      this.trigger('switch-entity');
      var $entity;
      if (event && event.type === 'click') {
       $entity = $(event.currentTarget);
      } else {
       $entity = $(selectedTab);
      }
      if (this.$('.tab.sl-tab').length) {
        this.$('.tab.sl-tab').removeClass('selected');
        $entity.parent().addClass('selected');
      }
      this.$('.switch-entity').removeClass('selected').addClass('unselected');
      $entity.removeClass('unselected').addClass('selected');
      if ($entity.data('name') === 'phone') {
        this.oldEmail = this.$input.val();
        this.togglePhoneInput();
        if (this.oldPhone) {
          this.$input.val(this.oldPhone);
        } else {
          this.phoneInputmaskView.setPhoneCodeValue(this.phoneInputmaskView.getPhoneCode());
        }
      } else {
        this.oldPhone = this.$input.val();
        this.toggleEmailInput();
        this.$input.val(this.oldEmail || '');
      }
    },

    /**
     * Переключение поля ввода на email
     */
    toggleEmailInput: function () {
      this.phoneInputmaskView.removeMask();
      this.$countryFlags.hide();
      this.$input.removeClass('input_phone');
      this.$input.attr({type: 'email', autocomplete: 'email', placeholder: 'pticane@mail.ru'});
    },

    /**
     * Переключение поля ввода на телефон
     */
    togglePhoneInput: function () {
      this.$input.addClass('input_phone');
      this.$input.attr({type: 'tel', autocomplete: 'tel'});
      this.phoneInputmaskView.render();
      this.$countryFlags.show();
    },
  });
})(jQuery);

}.call(window));